import { render } from "./RecordsRibbon.vue?vue&type=template&id=1e93484f"
import script from "./RecordsRibbon.vue?vue&type=script&lang=js"
export * from "./RecordsRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2025.48.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__